import classNames from 'classnames';

import { Tag } from '@flixbus/honeycomb-react';

import ActionMenu from 'common/ActivityChip/ActionMenu';
import { getActivityActions } from 'common/ActivityChip/ActionMenu/actionMenuFactory';
import { useActivityMutations } from 'common/ActivityChip/ActionMenu/useActivityMutation';

import styles from 'common/ActivityChip/styles.module.css';

const RroTimeOffAvailabilityEnabledLayout = ({
	config,
	isSelected,
	isStartInTimeWindow = true,
	isEndInTimeWindow = true,
	suppressNativeTitle = false,
}) => {
	const { renderType, header, fromTimestamp, toTimestamp, raw, crewMemberId } = config;

	const { toggleAvailability, updateAbsence, deleteAbsence, loading } = useActivityMutations();

	const activityActions = getActivityActions(
		{ ...raw, renderType, fromTimestamp, toTimestamp, crewMemberId },
		{
			onToggleAvailability: toggleAvailability,
			onUpdateAbsence: updateAbsence,
			onDeleteAbsence: deleteAbsence,
		}
	);

	const chipStyles = classNames(styles.activity, styles[renderType], {
		[styles.selected]: isSelected,
		[styles.openStart]: !isStartInTimeWindow,
		[styles.openEnd]: !isEndInTimeWindow,
	});

	return (
		<div {...(!suppressNativeTitle && { title: header })} className={chipStyles}>
			<div className={styles.handler}>
				<Tag extraClasses={styles.header} display="outlined" appearance="success">
					{header}
				</Tag>
				<div className={styles.menuspace} />
			</div>

			<ActionMenu items={activityActions} isLoading={loading} />
		</div>
	);
};

export default RroTimeOffAvailabilityEnabledLayout;
